import { ComponentBase } from "../core/ComponentBase.js";

export class EntryBranding extends ComponentBase {

    static styles = `
        .entry-page-wrapper {
            background: linear-gradient(135deg, var(--bs-primary-bg-subtle) 0%, var(--bs-tertiary-bg) 100%);
            width: 100%;
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 2rem;
        }

        .entry-panel {
            width: 100%;
            max-width: 900px;
            min-height: 550px;
            border: none;
            border-radius: var(--bs-border-radius-xl);
            overflow: hidden;
            box-shadow: var(--bs-box-shadow-lg);
        }

        .branding-pane {
            width: 45%;
            background-color: var(--bs-primary);
            color: var(--bs-primary-contrast, #fff);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 2rem;
            text-align: center;
        }

        .entry-branding-content .logo-container {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .entry-branding-content .logo-container i {
            font-size: 3rem;
        }

        .entry-branding-content .logo-text {
            font-family: 'Playfair Display', serif; /* A more elegant font for branding */
            font-weight: 700;
            font-size: var(--ab-text-lg);
            margin-left: 0.75rem;
        }

        .entry-branding-content .branding-title {
            font-weight: 600;
        }

        .entry-branding-content .branding-description {
            color: rgba(255, 255, 255, 0.8);
            margin: 1rem 0 2rem 0;
        }

        .form-pane {
            width: 55%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        @media (max-width: 767.98px) {
            .entry-panel {
                flex-direction: column !important;
                min-height: auto;
                max-width: 450px;
            }
            .branding-pane, .form-pane {
                width: 100% !important;
            }
        }

    `
    constructor(config) {
        super(config);
        this.currentPath = window.location.pathname;
        this._boundHandleRouteChange = this.handleRouteChange.bind(this);
        this.applyStyles();
    }

    static getDefaultConfig() {
        return {
            logoText: "AppBuilder",
            iconClass: "bi bi-shield-lock-fill",
        };
    }

    async initialize() {
        await super.initialize();
        this.appClient.events.local.on("route-changed", this._boundHandleRouteChange);
    }

    handleRouteChange() {
        if (this.currentPath !== window.location.pathname) {
            this.currentPath = window.location.pathname;
            if (this.container) {
                this.render();
            }
        }
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'entry-branding-content';
        }

        const isLoginPage = this.currentPath.includes('/login');
        const title = isLoginPage ? 'New Here?' : 'Already have an account?';
        const description = isLoginPage
            ? 'Create an account to get started.'
            : 'Log in to access your dashboard.';
        const buttonText = isLoginPage ? 'Create Account' : 'Log In';
        const buttonRoute = isLoginPage ? '/entry/signup' : '/entry/login';

        this.container.innerHTML = `
            <div id="entry-logo-container" class="logo-container mb-4"></div>
            <h2 class="branding-title">${this.t(title)}</h2>
            <p class="branding-description">${this.t(description)}</p>
            <a href="${this.appClient.layoutEngine.prefix}${buttonRoute}" class="btn btn-outline-light btn-lg cta-button">${this.t(buttonText)}</a>
        `;

        const logoContainer = this.container.querySelector('#entry-logo-container');
        const logoComponent = await this.createManagedComponent('LogoComponent', logoContainer, {
            displayMode: 'image',
            logoUrl: '/public/logo.png',
            imageHeight: '50px'
        });
        await logoComponent.render();

        this.appClient.tx.applyTranslations(this.container);
        return this.container;
    }

    destroy() {
        this.appClient.events.local.off("route-changed", this._boundHandleRouteChange);
        super.destroy();
    }
}